// AnswerMessage.jsx
import React, { useState } from 'react';
import { messagesApi } from './messagesApi';

const AnswerMessage = ({ message, onClose }) => {
    const [formData, setFormData] = useState({
        status: 'В роботі',
        text: ''
    });
    const [loading, setLoading] = useState(false);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.text.trim()) {
            alert('Будь ласка, введіть текст відповіді');
            return;
        }

        setLoading(true);

        try {
            const status = formData.status === 'Закрита' ? 'closed' : 'info';
            
            await messagesApi.addMessageAnswer(
                message._id,
                message.genInfo?.author?.name || '',
                message.genInfo?.author?.email || '',
                status,
                formData.text
            );

            alert('Відповідь успішно направлена користувачу!');
            onClose();
        } catch (error) {
            console.error('Error sending answer:', error);
            alert('Виникли проблеми при надсиланні відповіді. Спробуйте ще раз.');
        } finally {
            setLoading(false);
        }
    };

    if (!message.genInfo) {
        return <div className="text-center p-3">Дані повідомлення не завантажені</div>;
    }

    return (
        <div>
            {/* Message Info */}
            <div className="card mb-4">
                <div className="card-body">
                    <h6 className="card-title">Інформація про звернення</h6>
                    <div className="row">
                        <div className="col-md-6">
                            <p><strong>Автор:</strong> {message.genInfo.author.name}</p>
                            <p><strong>Пошта:</strong> {message.genInfo.author.email}</p>
                            <p><strong>Телефон:</strong> {message.genInfo.author.phone}</p>
                        </div>
                        <div className="col-md-6">
                            <p><strong>Дитина:</strong> {message.genInfo.child?.firstName || 'Не вказано'}</p>
                            <p><strong>Свідоцтво:</strong> {message.genInfo.child?.birthCertificateNumber || 'Не вказано'}</p>
                        </div>
                    </div>
                    
                    {/* Message History */}
                    <div className="mt-3">
                        <h6>Історія повідомлень ({message.messages?.length || 0})</h6>
                        <div className="message-history" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                            {message.messages?.map((msg, index) => (
                                <div 
                                    key={index} 
                                    className={`p-2 mb-2 rounded ${index % 2 === 0 ? 'bg-light' : 'bg-white border'}`}
                                >
                                    <small className="text-muted">
                                        <strong>{msg.from.name}</strong> • {new Date(msg.date).toLocaleString('uk-UA')}
                                    </small>
                                    <div>{msg.text}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Answer Form */}
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="status" className="form-label">Статус</label>
                    <select
                        id="status"
                        className="form-select"
                        value={formData.status}
                        onChange={(e) => handleInputChange('status', e.target.value)}
                        disabled={loading}
                    >
                        <option value="В роботі">В роботі</option>
                        <option value="Закрита">Закрита</option>
                    </select>
                </div>

                <div className="mb-3">
                    <label htmlFor="text" className="form-label">Відповідь</label>
                    <textarea
                        id="text"
                        className="form-control"
                        rows="4"
                        value={formData.text}
                        onChange={(e) => handleInputChange('text', e.target.value)}
                        placeholder="Введіть текст відповіді..."
                        disabled={loading}
                        required
                    />
                </div>

                <div className="d-flex gap-2">
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                Відправка...
                            </>
                        ) : (
                            'Надіслати відповідь'
                        )}
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Скасувати
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AnswerMessage;